export const CONTACT_FORM_ID = "contacto-form";
export const MODELS_SECTION_ID = "delivery-models";

export const scrollToId = (id: string) => {
  const element = document.getElementById(id);
  if (element) {
    element.scrollIntoView({ behavior: "smooth" });
  }
};

export const scrollToContact = () => scrollToId(CONTACT_FORM_ID);
